/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Track_Intensity_HotInputs */

const en_ui_track_intensity_hot = /** @type {(inputs: Ui_Track_Intensity_HotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hot`)
};

const de_ui_track_intensity_hot = /** @type {(inputs: Ui_Track_Intensity_HotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heiß`)
};

/**
* | output |
* | --- |
* | "Hot" |
*
* @param {Ui_Track_Intensity_HotInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_track_intensity_hot = /** @type {((inputs?: Ui_Track_Intensity_HotInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Track_Intensity_HotInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_track_intensity_hot(inputs)
	return de_ui_track_intensity_hot(inputs)
});